import { Overlay } from "@blueprintjs/core";
import React, { Component } from 'react';

/**
 * Renders: Overlay 
 * @props {Object} children
 * @returns Overlay
 */
class StandardOverlay extends Component {
	render() {
		return <Overlay
			autoFocus = {true}
			canEscapeKeyClose = {true}
			canOutsideClickClose = {false}
			enforceFocus = {true}
			hasBackdrop = {true}
			inline = {false}
			isOpen = {this.props.isOpen}
			className= "pt-overlay-scroll-container"
		>
			{this.props.children}
		</Overlay>
	}
}

export default StandardOverlay;



// WEBPACK FOOTER //
// ./src/components/blueprintWrappers/StandardOverlay.js